<template>
    <div class="onlineSignPurpose">
        <bv-top></bv-top>
      <van-cell></van-cell>
        <van-cell-group>
          <van-field
              readonly
              required
              clickable
              :value="purposeName"
              label="查询用途"
              placeholder="请选择查询用途"
              input-align="center"
              @click="showpicker = true"
          />
          <van-popup v-model="showpicker" position="bottom" round get-container="#app">
            <van-picker
                show-toolbar
                :columns="purposeList"
                @confirm="onConfirm"
                value-key="purposeName"
                @cancel="showpicker = false"
            >
            </van-picker>
          </van-popup>
        </van-cell-group>
        <van-row type="flex" justify="center">
            <van-col span="22">
                <van-button type="primary" size="large" @click="verifyPurpose" :disabled="isDownloading">查询下载</van-button>
            </van-col>
        </van-row>

    </div>
</template>

<script>
    import Top from '@/views/components/Top'
    import {queryPurposeList,onlineSineQuery} from '@/api/maintainFund/maintainFund'
    import {Toast} from "vant";

    export default {
        name: "OnlineSign",
        data() {
            return {
                showpicker: false,
                purposeName: '',
                purposeNo: '',
                purposeList: [],
                sysGuid: '',
                isDownloading: false
            }
        },
        created() {
          this.fetchData()
        },
        watch: {
        },
        components: {
            BvTop: Top,
        },
        methods: {
          //全屏加载提示
          showLoading() {
            Toast.loading({
              // 持续展示 toast
              duration: 0,
              mask: true,
              message: '加载中...'
            });
          },
          fetchData() {
            this.showLoading();
            this.purposeNo = "";
            let param = {
              purposeName:  ""
            }
            queryPurposeList(param).then(response => {
              console.log(response)
              this.purposeList = response.data;
              Toast.clear();
            }).catch(() => {
              this.purposeList = []
            });
          },
          onConfirm(value) {
            this.purposeName = value.purposeName;
            this.purposeNo = value.purposeNo;
            this.showpicker = false;
          },
          async verifyPurpose() {
            // 1. 检查是否已选择用途
            if (!this.purposeNo) {
              Toast('请先选择查询用途');
              return;
            }

            try {
              // 2. 设置下载中状态
              this.isDownloading = true;
              Toast.loading({
                duration: 0,
                mask: true,
                message: '文件生成中...',
                forbidClick: true  // 禁止背景点击
              });

              // 3. 请求数据
              const purpose = { purposeNo: this.purposeNo };
              const res = await onlineSineQuery(purpose);
              this.sysGuid = res.data.sysGuid;

              // 4. 创建下载链接
              const link = document.createElement('a');
              link.href = `${this.$APP_ROOT}/api/maintenance-fund/weixin/contractOnlineSign/${this.sysGuid}`;
              link.download = this.fileName;
              link.style.display = 'none';
              document.body.appendChild(link);

              // 5. 触发下载并监听完成事件
              link.click();

              // 6. 模拟下载完成（实际需要根据业务调整）
              setTimeout(() => {
                document.body.removeChild(link);
                Toast.clear();

                // 显示下载成功提示
                Toast.success({
                  message: '下载成功！',
                  duration: 2000
                });

                // 重置下载状态
                this.isDownloading = false;
              }, 6000); // 根据实际网络情况调整

            } catch (error) {
              // 错误处理
              Toast.clear();
              Toast.fail('下载失败，请重试');
              console.error('下载失败:', error);
              this.isDownloading = false;
            }
          }
        }
    }
</script>

<style lang='scss' scoped>
/* 添加禁用状态下的按钮样式 */
.van-button--disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
